import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { FormFieldsModule } from '@app/base-components';
import { I18nModule } from 'haba-core';

import { UserModule } from '../../user/user.module';
import { ProductAdvisorComponent } from './product-advisor/product-advisor.component';
import { ChatMessageComponent } from './chat-message/chat-message.component';
import { HanaOndemandModule } from 'haba-emporix';

@NgModule({
  imports: [
    CommonModule,
    I18nModule,
    ReactiveFormsModule,
    FormFieldsModule,
    RouterModule.forChild([
      {
        path: 'product-advisor',
        component: ProductAdvisorComponent,
      },
    ]),
    UserModule,
    ProductAdvisorComponent,
    ChatMessageComponent,
    HanaOndemandModule,
  ],
  exports: [ProductAdvisorComponent, ChatMessageComponent],
})
export class ProductAdvisorModule {}
